import { Component, OnInit, ElementRef, ViewChild, OnDestroy, Inject  } from '@angular/core';
import { DashboardService } from '../services/dashboard.service';
import { NavService } from '../services/nav.service';
import { TranslatorService } from '../services/translate.service';
import { ChatbotService } from '../services/chatbot.service';
import { UserSessionService } from '../services/user-session.service';
import { v4 as uuidv4 } from 'uuid';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.scss']
})
export class ChatBotComponent implements OnInit {

  @ViewChild('chatMessages') chatMessages: ElementRef;
  @ViewChild('chatContainer') chatContainer: ElementRef;

  chatVisible: boolean = false;
  firstMessage: { text: string, user: boolean, manuals?: any } = { text: 'Ciao, sono Acrobottino. Come posso aiutarti? ', user: false }
  messages: { text: string, user: boolean, manuals?: any }[] = [this.firstMessage];
  userInput: string = '';
  loading: boolean = false;

  // Aggiungi proprietà per dimensioni chat
  chatWidth: number = 400;
  chatHeight: number = 600;
  resizing: boolean = false;
  moving: boolean = false; // Nuova proprietà per overlay durante il drag
  lastMouseX: number = 0;
  lastMouseY: number = 0;

  // Aggiungi proprietà per posizione chat
  chatLeft: number = 0;
  chatTop: number = 0;
  dragging: boolean = false;
  dragOffsetX: number = 0;
  dragOffsetY: number = 0;
  resizeDirection: string | null = null;

  // Proprietà per posizione del bottone flottante
  chatButtonLeft: number = 0;
  chatButtonTop: number = 0;
  draggingButton: boolean = false;
  dragButtonOffsetX: number = 0;
  dragButtonOffsetY: number = 0;
  buttonMoving: boolean = false; // Overlay per drag bottone

  constructor(public navService: NavService,
    public translate: TranslatorService,
    public chatbotService: ChatbotService,
    public userSessionService: UserSessionService,
    private matDialog: MatDialog
  ) {}

  toggleChat() {
    let usersessionId = uuidv4()
    this.chatVisible = !this.chatVisible;
    if (this.chatVisible) {
      this.userSessionService.saveState('userChatbotSession', usersessionId);
      // Carica dimensioni e posizione da localStorage
      const w = localStorage.getItem('chatbotWidth');
      const h = localStorage.getItem('chatbotHeight');
      const l = localStorage.getItem('chatbotLeft');
      const t = localStorage.getItem('chatbotTop');
      if (w && h) {
        this.chatWidth = +w;
        this.chatHeight = +h;
      }
      if (l && t) {
        this.chatLeft = +l;
        this.chatTop = +t;
      } else {
        // Default: bottom right
        this.chatLeft = window.innerWidth - this.chatWidth - 20;
        this.chatTop = window.innerHeight - this.chatHeight - 80;
      }
      // Verifica se il box chat è visibile nella viewport
      const margin = 30;
      let changed = false;
      if (
        this.chatLeft < margin ||
        this.chatLeft > window.innerWidth - this.chatWidth - margin ||
        this.chatTop < margin ||
        this.chatTop > window.innerHeight - this.chatHeight - margin
      ) {
        // Se fuori dallo schermo, riposiziona in basso a destra
        this.chatLeft = window.innerWidth - this.chatWidth - margin;
        this.chatTop = window.innerHeight - this.chatHeight - margin - 70; // 60px per lasciare spazio al bottone
        changed = true;
      }
      if (changed) {
        localStorage.setItem('chatbotLeft', this.chatLeft.toString());
        localStorage.setItem('chatbotTop', this.chatTop.toString());
      }
    } else {
      this.userSessionService.saveState('userChatbotSession', null);
      this.messages = [this.firstMessage];
    }
    if (this.chatVisible) {
      setTimeout(() => this.scrollChatToBottom(), 0);
    }
  }

  sendMessage() {
    if (this.userInput.trim()) {
      let currentMessage = this.userInput;
      this.messages.push({ text: currentMessage, user: true });
      this.userInput = '';
      this.loading = true;
      let userChatbotSession = this.userSessionService.getState('userChatbotSession');
      this.chatbotService.askTheChatbot(userChatbotSession, currentMessage).subscribe((res) => {
        console.log(res)
        this.loading = false;
        let manuals: any = []
        
        if (res?.page_numbers?.length > 0) {
          res?.page_numbers.forEach((manual: any) => {
            manuals.push({
              name: manual.file_name,
              fileUrl: manual.file_url,
              pageNumber: manual.page_number,
              images: manual.image_url
            })
          });
        }


        setTimeout(() => this.scrollChatToBottom(), 0);
        this.getBotResponse(res.answer, manuals);
      });
    }
  }

  getBotResponse(answer: string, manuals: any) {
    // Simulate a bot response
    setTimeout(() => {
      this.messages.push({ text: answer, user: false, manuals: manuals });
      this.scrollChatToBottom();
    }, 1000);
  }

  sendFeedback(status: boolean) {
    let userChatbotSession = this.userSessionService.getState('userChatbotSession');
    this.chatbotService.chatbotHistory(userChatbotSession, status).subscribe((res) => {
      console.log(res)
    });
  }

  scrollChatToBottom() {
    try {
      this.chatMessages.nativeElement.scrollTop = this.chatMessages.nativeElement.scrollHeight;
    } catch (err) { }
  }

  openImageDialog(imageUrl: string): void {
    this.matDialog.open(ImageDialogComponent, {
      data: { imageUrl: imageUrl },
      width: '80%',
      maxWidth: '800px',
      scrollStrategy: new NoopScrollStrategy(),
    });
  }

  // Gestione resize
  onResizeMouseDown(event: MouseEvent, direction: string) {
    event.preventDefault();
    event.stopPropagation();
    this.resizing = true;
    this.resizeDirection = direction;
    this.lastMouseX = event.clientX;
    this.lastMouseY = event.clientY;
    document.addEventListener('mousemove', this.onResizeMouseMove);
    document.addEventListener('mouseup', this.onResizeMouseUp);
  }

  onResizeMouseMove = (event: MouseEvent) => {
    if (!this.resizing) return;
    const dx = event.clientX - this.lastMouseX;
    const dy = event.clientY - this.lastMouseY;
    let newWidth = this.chatWidth;
    let newHeight = this.chatHeight;
    let newLeft = this.chatLeft;
    let newTop = this.chatTop;
    const minWidth = 300;
    const minHeight = 400;
    const maxWidth = window.innerWidth - 10;
    const maxHeight = window.innerHeight - 10;

    switch (this.resizeDirection) {
      case 'right':
        newWidth = Math.max(minWidth, Math.min(maxWidth - newLeft, this.chatWidth + dx));
        break;
      case 'left':
        newWidth = Math.max(minWidth, Math.min(maxWidth - (this.chatLeft + dx), this.chatWidth - dx));
        newLeft = Math.max(0, Math.min(this.chatLeft + dx, window.innerWidth - minWidth));
        break;
      case 'bottom':
        newHeight = Math.max(minHeight, Math.min(maxHeight - newTop, this.chatHeight + dy));
        break;
      case 'top':
        newHeight = Math.max(minHeight, Math.min(maxHeight - (this.chatTop + dy), this.chatHeight - dy));
        newTop = Math.max(0, Math.min(this.chatTop + dy, window.innerHeight - minHeight));
        break;
      case 'bottom-right':
        newWidth = Math.max(minWidth, Math.min(maxWidth - newLeft, this.chatWidth + dx));
        newHeight = Math.max(minHeight, Math.min(maxHeight - newTop, this.chatHeight + dy));
        break;
      case 'bottom-left':
        newWidth = Math.max(minWidth, Math.min(maxWidth - (this.chatLeft + dx), this.chatWidth - dx));
        newLeft = Math.max(0, Math.min(this.chatLeft + dx, window.innerWidth - minWidth));
        newHeight = Math.max(minHeight, Math.min(maxHeight - newTop, this.chatHeight + dy));
        break;
      case 'top-right':
        newWidth = Math.max(minWidth, Math.min(maxWidth - newLeft, this.chatWidth + dx));
        newHeight = Math.max(minHeight, Math.min(maxHeight - (this.chatTop + dy), this.chatHeight - dy));
        newTop = Math.max(0, Math.min(this.chatTop + dy, window.innerHeight - minHeight));
        break;
      case 'top-left':
        newWidth = Math.max(minWidth, Math.min(maxWidth - (this.chatLeft + dx), this.chatWidth - dx));
        newLeft = Math.max(0, Math.min(this.chatLeft + dx, window.innerWidth - minWidth));
        newHeight = Math.max(minHeight, Math.min(maxHeight - (this.chatTop + dy), this.chatHeight - dy));
        newTop = Math.max(0, Math.min(this.chatTop + dy, window.innerHeight - minHeight));
        break;
    }
    // Blocca la chat all'interno dello schermo
    if (newLeft + newWidth > window.innerWidth) {
      newWidth = window.innerWidth - newLeft;
    }
    if (newTop + newHeight > window.innerHeight) {
      newHeight = window.innerHeight - newTop;
    }
    this.chatWidth = newWidth;
    this.chatHeight = newHeight;
    this.chatLeft = newLeft;
    this.chatTop = newTop;
    this.lastMouseX = event.clientX;
    this.lastMouseY = event.clientY;
  }

  onResizeMouseUp = () => {
    if (this.resizing) {
      this.resizing = false;
      this.resizeDirection = null;
      // Salva preferenze in localStorage
      localStorage.setItem('chatbotWidth', this.chatWidth.toString());
      localStorage.setItem('chatbotHeight', this.chatHeight.toString());
      localStorage.setItem('chatbotLeft', this.chatLeft.toString());
      localStorage.setItem('chatbotTop', this.chatTop.toString());
    }
    document.removeEventListener('mousemove', this.onResizeMouseMove);
    document.removeEventListener('mouseup', this.onResizeMouseUp);
  }

  // --- DRAG MANUALE (salva posizione) ---
  onDragStart(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('resize-handle')) return;
    this.dragging = true;
    this.moving = true;
    this.dragOffsetX = event.clientX - this.chatLeft;
    this.dragOffsetY = event.clientY - this.chatTop;
    document.addEventListener('mousemove', this.onDragMove);
    document.addEventListener('mouseup', this.onDragEnd);
  }

  onDragMove = (event: MouseEvent) => {
    if (!this.dragging) return;
    this.chatLeft = Math.max(0, Math.min(window.innerWidth - this.chatWidth, event.clientX - this.dragOffsetX));
    this.chatTop = Math.max(0, Math.min(window.innerHeight - this.chatHeight, event.clientY - this.dragOffsetY));
  }

  onDragEnd = () => {
    if (this.dragging) {
      this.dragging = false;
      this.moving = false;
      // Salva posizione
      localStorage.setItem('chatbotLeft', this.chatLeft.toString());
      localStorage.setItem('chatbotTop', this.chatTop.toString());
    }
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);
  }

  ngOnInit(): void {
    // Carica posizione bottone chat se presente
    const btnL = localStorage.getItem('chatButtonLeft');
    const btnT = localStorage.getItem('chatButtonTop');
    if (btnL && btnT) {
      this.chatButtonLeft = +btnL;
      this.chatButtonTop = +btnT;
    } else {
      // Default: bottom right
      this.chatButtonLeft = window.innerWidth - 100;
      this.chatButtonTop = window.innerHeight - 100;
    }

    // Verifica se il bottone è visibile nella viewport
    const buttonWidth = 70; // larghezza stimata del bottone
    const buttonHeight = 70; // altezza stimata del bottone
    const margin = 10;
    let changed = false;
    if (
      this.chatButtonLeft < margin ||
      this.chatButtonLeft > window.innerWidth - buttonWidth - margin ||
      this.chatButtonTop < margin ||
      this.chatButtonTop > window.innerHeight - buttonHeight - margin
    ) {
      // Se fuori dallo schermo, riposiziona in basso a destra
      this.chatButtonLeft = window.innerWidth - buttonWidth - margin;
      this.chatButtonTop = window.innerHeight - buttonHeight - margin;
      changed = true;
    }
    if (changed) {
      localStorage.setItem('chatButtonLeft', this.chatButtonLeft.toString());
      localStorage.setItem('chatButtonTop', this.chatButtonTop.toString());
    }
  }

  onChatButtonDragStart(event: MouseEvent) {
    this.draggingButton = true;
    this.buttonMoving = true;
    this.dragButtonOffsetX = event.clientX - this.chatButtonLeft;
    this.dragButtonOffsetY = event.clientY - this.chatButtonTop;
    document.addEventListener('mousemove', this.onChatButtonDragMove);
    document.addEventListener('mouseup', this.onChatButtonDragEnd);
  }

  onChatButtonDragMove = (event: MouseEvent) => {
    if (!this.draggingButton) return;
    this.chatButtonLeft = Math.max(0, Math.min(window.innerWidth - 60, event.clientX - this.dragButtonOffsetX));
    this.chatButtonTop = Math.max(0, Math.min(window.innerHeight - 60, event.clientY - this.dragButtonOffsetY));
  }

  onChatButtonDragEnd = () => {
    if (this.draggingButton) {
      this.draggingButton = false;
      this.buttonMoving = false;
      localStorage.setItem('chatButtonLeft', this.chatButtonLeft.toString());
      localStorage.setItem('chatButtonTop', this.chatButtonTop.toString());
    }
    document.removeEventListener('mousemove', this.onChatButtonDragMove);
    document.removeEventListener('mouseup', this.onChatButtonDragEnd);
  }

  resetChatPreferences() {
    localStorage.removeItem('chatbotWidth');
    localStorage.removeItem('chatbotHeight');
    localStorage.removeItem('chatbotLeft');
    localStorage.removeItem('chatbotTop');
    localStorage.removeItem('chatButtonLeft');
    localStorage.removeItem('chatButtonTop');
    // Reset to default values
    this.chatWidth = 400;
    this.chatHeight = 600;
    this.chatLeft = window.innerWidth - 400 - 30;
    this.chatTop = window.innerHeight - 600 - 80;
    this.chatButtonLeft = window.innerWidth - 80;
    this.chatButtonTop = window.innerHeight - 80;
  }

  ngOnDestroy(): void {
    document.removeEventListener('mousemove', this.onResizeMouseMove);
    document.removeEventListener('mouseup', this.onResizeMouseUp);
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);
    document.removeEventListener('mousemove', this.onChatButtonDragMove);
    document.removeEventListener('mouseup', this.onChatButtonDragEnd);
  }

}

// Aggiungi un componente per il dialog dell'immagine
@Component({
  selector: 'image-dialog',
  template: `
    <div mat-dialog-content>
      <img [src]="data.imageUrl" alt="Immagine" style="width: 100%;">
    </div>
  `,
})
export class ImageDialogComponent {
  constructor(
      public dialogRef: MatDialogRef<ImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}